import { Suspense, lazy, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SiteLayout } from "@/components/layout/SiteLayout";
import HomePage from "@/pages/HomePage";

const ProductsPage = lazy(() => import("@/pages/ProductsPage"));
const ProductDetailPage = lazy(() => import("@/pages/ProductDetailPage"));
const AboutPage = lazy(() => import("@/pages/AboutPage"));
const ManufacturingPage = lazy(() => import("@/pages/ManufacturingPage"));
const QualityPage = lazy(() => import("@/pages/QualityPage"));
const BlogPage = lazy(() => import("@/pages/BlogPage"));
const BlogPostPage = lazy(() => import("@/pages/BlogPostPage"));
const ContactPage = lazy(() => import("@/pages/ContactPage"));
const FAQPage = lazy(() => import("@/pages/FAQPage"));
const SitemapPage = lazy(() => import("@/pages/SitemapPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const TrackPageViews = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const id = setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view",
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 200);
    return () => clearTimeout(id);
  }, [pathname, search]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <TrackPageViews />
      <SiteLayout>
        <Suspense fallback={<div className="min-h-[60vh]" />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:slug" element={<ProductDetailPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/manufacturing" element={<ManufacturingPage />} />
            <Route path="/quality" element={<QualityPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </SiteLayout>
    </BrowserRouter>
  );
}

export default App;
